import { Link } from "react-router-dom";
import CultArrow from "./Icons/CultArrow";

export interface Props {
  bgColor?: string;
  bgHoverColor?: string;
  text?: string;
  textColor?: string;
  textHoverColor?: string;
  className?: string;
  borderColor?: string;
  borderHoverColor?: string;
  arrowColor?: string;
  arrowHoverColor?: string;
  path?: string;
}

const ContactButton = ({
  bgColor = "bg-black",
  bgHoverColor = "hover:bg-white",
  text = "Get in touch",
  textColor = "text-white",
  textHoverColor = "hover:text-black",
  borderColor = "border-white",
  borderHoverColor = "hover:border-white",
  arrowColor = "stroke-white",
  arrowHoverColor = "group-hover:stroke-white",
  className,
  path = "/contact",
}: Props) => {
  return (
    <div className={`flex items-center group h-fit ${className}`}>
      <Link
        to={path}
        className={`flex items-center w-full justify-center font-Light ${textColor} ${textHoverColor} ${bgColor} ${bgHoverColor} border-1 ${borderColor} ${borderHoverColor} transition-all duration-300 ease-in-out px-6 py-[6px] overflow-hidden`}
      >
        <p
          className="text-sm md:text-lg lg:text-base xl:text-xl 3xl:text-xl font-Light 
          transform transition-transform duration-300 ease-in-out group-hover:-translate-x-[6px]"
        >
          {text}
        </p>

        <CultArrow
          className={`${arrowColor} ${arrowHoverColor} transform transition-all duration-300 ease-in-out group-hover:translate-x-[6px]`}
        />
      </Link>
    </div>
  );
};

export default ContactButton;
